// tslint:disable-next-line:import-spacing
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {EventEmitter, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {CommandService} from '@core/services/command.service';
import {DialogService} from '@shared/services/dialog-service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {FileManagementService} from '@core/services/file-management.service';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {PlatformSidebarService} from '@shared/components/platform-sidebar/store/platform-sidebar.service';
import {FuseSidebarService} from '@barebone-fuse/@fuse/components/sidebar/sidebar.service';

@Injectable({
  providedIn: 'root',
})
export class AuditTrackerDetailsHandler implements IPlatformToolHandler {
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();
  magicLinkModel: MagicLinkModel;
  selectedTabModel: TabModel;
  ngUnsubscribe = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  private fieldSections: any;
  private selectedFieldSectionIndex: any;

  constructor(private commandService: CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
              private platformSidebarService: PlatformSidebarService,
              private sidebarService: FuseSidebarService,
  ) {
  }

  executeCommand(command: PlatformCommand) {
    console.log('[audit-tracker-platform-command] onPlatformTool Handler Command', command);
    command.fieldValues['FromDetailPage'] = true;
    command.fieldValues['AuditStageId'] = this.selectedTabModel.id;
    command.fieldValues['StageName'] = this.selectedTabModel.name;
    if (command.fieldValues['CommandHandler']) {
      const commandHandler = RootDynamicComponentHelper.getComponent(command.fieldValues['CommandHandler']);
      if (commandHandler) {
        console.log(command);
        commandHandler.executeCommand(command, this, null);
        return;
      }
    }
    switch (command.name) {
      case 'InformationBar':
        // do nothing
        // just a dummy commit
        break;
      case 'DeleteAuditStageCommand':
        this.dialogService.showConfirmDialog('Delete current stage?', 'Yes', 'No',
          `You can remove the current stage '${this.selectedTabModel.name}' if you think it is mistakenly created, or you need to create another one. Please note that this can not be undone and all of the records will be lost.`,
          `Are you sure want to delete the stage '${this.selectedTabModel.name}'?`).subscribe( res => {
          if (res.action === 'OK') {
            this.executeCommandToApi(command);
          }});
        break;
      // case 'ArchiveCaseCommand':
      //   this.showArchiveCaseDialog(command);
      //   break;
      // case 'CloseCaseCommand':
      //   this.showCloseCaseDialog(command);
      //   break;
      // case 'StartWorkFlowCommand':
      //   this.showStartWorkflowDialog(command);
      //   break;
      default:
        this.executeCommandToApi(command);
        break;
    }
  }

  valueChanged($event) {
    console.log('Inside Handler', $event);
    if (this.handleAction($event)) {
      return;
    }
    if (this.handleByFieldDefinition($event)) {
      return;
    }
    if (this.handleCommand($event)) {
      return;
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
    // update commands with selected tab id
    if (this.magicLinkModel && this.magicLinkModel.breadcrumbBar && this.magicLinkModel.breadcrumbBar.items) {
      for (const item  of this.magicLinkModel.breadcrumbBar.items) {
        for (const command of item.commands) {
          command.fieldValues['AuditStageId'] = selectedTab.id;
          command.fieldValues['SourceType'] = selectedTab.tabData['SourceType'];
          command.fieldValues['StageName'] = selectedTab.name;
        }
      }
    }

  }

  destroy() {
    if (this.sidebarService.getSidebar('rightsidebar')) {
      this.sidebarService.getSidebar('rightsidebar').close();
      this.sidebarService.getSidebar('rightsidebar').fold();
    }
    this.platformSidebarService.hideSidebarIcon('Audit Tracker');
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      command.projectId = '[PROJECT_ID]';
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('[audit-tracker-platform-command] Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
            return;
          }

          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (commandResponse.fieldValues['ErrorMessage']) {
            this.snackBarService.showError(commandResponse.fieldValues['SnackBarMessage']);
          }

          if (commandResponse.fieldValues['FileId']) {
            const fileId = commandResponse.fieldValues['FileId'];
            const fileName = commandResponse.fieldValues['FileName'];

            this.downloadFile(fileId, fileName);
          }

          if (commandResponse.fieldValues['PlatformLinkModel']) {
            this.magicLinkModel = commandResponse.fieldValues['PlatformLinkModel'];
            this.magicLinkModelValueChangedHandler({
              id: 'PlatformToolContainerComponent', value: commandResponse.fieldValues['PlatformLinkModel'],
              magicLinkModel: this.magicLinkModel
            });
          } else {
            console.log('Url not found');
          }
          this.invalidateSubject.invalidate();
          this.invalidateSubject.invalidate('CardHolder');
        },
        error => {
          this.fuseSplashScreenService.hide();
        });
    }
  }

  private handleCommand($event): boolean {
    if ($event.command) {
      switch ($event.command.name) {
        case 'CommandName':
          // Handle the Command
          return true;
        default:
          this.executeCommand($event.command);
          return true;
      }
    }
    return false;
  }

  private handleAction($event): boolean {
    console.log('Inside handleAction');
    if ($event && $event.action) {
      const item = $event.item;
      const command = this.magicLinkModel.additionalCommands[$event.action.id];
      if (command) {
        // command.fieldValues['AuditStageId'] = item.id;
        command.fieldValues['AuditStageRecordId'] = item.id;
        this.executeCommand(command);
        return true;
      }

      if ($event.fieldDefinition.key === "AssignedTo") return false;

      switch ($event.action.id) {
        case 'Edit':
          this.edit($event);
          return true;
        case 'TagsUpdated':
          this.updateAuditStageRecord($event);
          return true;
      }
    }
    return false;
  }

  private handleByFieldDefinition($event): boolean {
    console.log('Inside handleByFieldDefinition');

    switch ($event.fieldDefinition.key) {
      case 'Workflow':
        this.startWorkflow($event.item);
        return true;
      case 'Documentation':
        const showDocumentCommand = this.magicLinkModel.additionalCommands['ShowDocuments'];
        this.executeCommandToApi(showDocumentCommand);
        return true;
      case 'Task':
        console.log(`==> ${$event.fieldDefinition.key} is updated`);
        this.onTaskUpdate($event.item);
        break;
      case "AssignedTo":
        let command = this.magicLinkModel.additionalCommands[$event.fieldDefinition?.key];
        if (command) {
          // command.fieldValues['AuditStageId'] = item.id;
          command.fieldValues['AuditStageRecordId'] = $event.item.id;
          command.fieldValues['FieldHeader'] = $event.fieldDefinition.header;
          command = JSON.parse(JSON.stringify(command));
          this.executeCommand(command);
        }
        return true;
    }

    const command = this.magicLinkModel.additionalCommands[$event.fieldDefinition.key];
    if (command) {
      if ($event.item.cells['FlowExecutionId'] && $event.item.cells['FlowExecutionId'].value) {
        command.fieldValues['FlowExecutionId'] = $event.item.cells['FlowExecutionId'].value;
      }
      // command.fieldValues['AuditStageId'] = $event.item.id;
      command.fieldValues['AuditStageRecordId'] = $event.item.id;
      command.fieldValues['FromDetailPage'] = true;
      this.executeCommand(command);
      return true;
    }
    return false;
  }

  private onTaskUpdate(item: any) {
    const command = new PlatformCommand('UpdateTaskInfoCommand', 'AuditTrackerApi');
    command.fieldValues['AuditStageRecordId'] = item.id;
    this.executeCommandToApi(command);
  }

  private updateAuditStageRecord($event) {
    const item = {id: $event.item.id, fieldValues: {}};
    const value = $event.item.cells[$event.fieldDefinition.key].value;
    item.fieldValues[$event.fieldDefinition.key] = value;
    const command = new PlatformCommand('UpdateAuditStageRecordCommand', 'AuditTrackerApi');
    command.fieldValues['AuditStageRecordId'] = $event.item.id;
    command.fieldValues['FieldKey'] = $event.fieldDefinition.key;
    command.fieldValues['FieldHeader'] = $event.fieldDefinition.header;
    command.fieldValues['DataType'] = $event.fieldDefinition.dataType;
    command.fieldValues['PlatformLinkId'] = this.magicLinkModel.id;
    command.fieldValues['Value'] = value;
    this.executeCommandToApi(command);
  }

  private edit($event) {
    this.openEditor($event);
  }

  private openEditor($event) {
    const originalValue = $event.item.cells[$event.fieldDefinition.key]?.value;
    this.dialogService.showCellEditorDialog($event.item, $event.fieldDefinition).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      console.log('After close state: ', state);
      if (state.action === 'OK') {
        this.updateAuditStageRecord($event);
      } else {
        // change back to original value
        $event.item.cells[$event.fieldDefinition.key].value = originalValue;
      }
    });
  }

  private downloadFile(fileId: string, fileName: string) {
    this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
      this.fileManagementService.openSaveFileWindow(payload, fileName);
      this.fuseSplashScreenService.hide();
    });
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }

  onFieldSectionIndexChanged($event: any): void {
    console.log('Inside onFieldSectionIndexChanged');
    console.log($event);
    this.selectedFieldSectionIndex = $event;
    this.updateBreadCrumbCommands();
  }

  onFieldSectionChanged($event: any): void {
    console.log('Inside onFieldSectionChanged');
    console.log($event);
    this.fieldSections = $event;
    this.updateBreadCrumbCommands();
  }

  private updateBreadCrumbCommands() {
    if (this.fieldSections && this.fieldSections.length) {
      const fieldSection = this.fieldSections[this.selectedFieldSectionIndex];
      if (fieldSection && this.magicLinkModel && this.magicLinkModel.breadcrumbBar && this.magicLinkModel.breadcrumbBar.items) {
        for (const item of this.magicLinkModel.breadcrumbBar.items) {
          for (const command of item.commands) {
            command.fieldValues['FieldSectionId'] = fieldSection.id;
          }
        }
      }
    }
  }

  private startWorkflow(item) {
    if (!item.cells['InternalDueDate'] || !item.cells['InternalDueDate']?.value) {
      this.dialogService.showDialogMessage('Internal Due Date is Required', 'Please set the internal due date first.');
    } else {
      const command = this.magicLinkModel.additionalCommands['Workflow'];
      command.fieldValues['AuditStageRecordId'] = item.id;
      const commandHandler = RootDynamicComponentHelper.getComponent('StartWorkFlowCommandHandler');
      if (commandHandler) {
        command.fieldValues['AuditStageId'] = this.selectedTabModel.id;
        command.fieldValues['StageName'] = this.selectedTabModel.name;
        command.fieldValues['FieldKey'] = 'Workflow';
        if (item.cells['Workflow'] && item.cells['Workflow'].value) {
          command.fieldValues['Workflow'] =  item.cells['Workflow'].value;
        }
        commandHandler.executeCommand(command, this, null);
      }
    }
  }
}
